import styled, { css } from 'styled-components';
import { Dropdown, Col } from 'react-bootstrap';

import {
  PRIMARY_BLUE,
  ERROR_RED,
  MEDIUM_GREY,
  BLACK,
  LIGHTEST_GREY,
  WHITE,
  DARK_BLACK
} from 'constants/colours';
import Badge from 'components/common/other/Badge';

export const Toggle = styled(Dropdown.Toggle)<{ $hasError: boolean; $simpleToggle: boolean }>(
  ({ $hasError, $simpleToggle }) => css`
    border-color: ${$hasError && `${ERROR_RED} !important`};
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: ${!$simpleToggle && '100%'};
    min-height: ${$simpleToggle && 'auto'};
    padding-right: 40px;
    padding: ${$simpleToggle && '2px 4px'};
    background: ${$simpleToggle && LIGHTEST_GREY};
    color: ${BLACK};
    font-weight: ${$simpleToggle ? '500' : '400'};
    font-size: ${$simpleToggle && '10px'};
    font-family: ${$simpleToggle && 'Poppins'};
    &::after {
      display: ${$simpleToggle && 'none'};
    }
    :disabled {
      pointer-events: none;
    }
  `
);

export const TagsWrapper = styled.div`
  margin-bottom: 8px;
`;

export const Tag = styled(Badge)`
  margin: 8px 8px 0 0;
`;

export const TagCloseBtn = styled.button`
  border: none;
  background: none;
  color: ${PRIMARY_BLUE};
  margin-left: 8px;
`;

export const DropdownContent = styled(Dropdown.Menu)`
  width: 100%;
`;

export const ButtonSection = styled.div`
  margin: 16px 0 8px 16px;
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;

export const NoResultsText = styled.p`
  padding: 1rem;
  color: ${MEDIUM_GREY};
  text-align: center;
`;

export const DropdownItem = styled(Dropdown.Item)<{
  $compact: boolean;
  $isMultiSelect: boolean;
}>(
  ({ $compact, $isMultiSelect }) => css`
    padding: ${$compact && '4px 16px'};
    padding-top: ${$isMultiSelect && '12px'};
    padding-bottom: ${$isMultiSelect && '0px'};
    > .a {
      background-color: ${$isMultiSelect && WHITE}!;
      color: ${$isMultiSelect && DARK_BLACK}!;
    }
  `
);

export const ItemCol = styled(Col)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 0px;
  padding-bottom: 2px;
`;

export const Image = styled.img`
  border-radius: 4px;
  width: 100%;
`;

export const SelectButtonWrapper = styled.div`
  float: right;
  margin: 16px;
`;
